import { Outlet } from 'react-router-dom';
import { useBranding } from '../contexts/BrandingContext';

export default function AuthLayout() {
  const branding = useBranding();

  return (
    <div className="min-h-screen flex">
      {/* Left panel — branding */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden flex-col justify-between text-white p-12">
        <img
          src="/images/hero-banner.png"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0b1023]/85" />
        <div className="relative">
          <img
            src={branding.logo_url}
            alt={branding.brand_name}
            className="h-10 brightness-0 invert"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
        <div className="relative">
          <h1 className="text-4xl font-bold mb-4">{branding.brand_name}</h1>
          <p className="text-lg text-blue-100/80">{branding.brand_tagline}</p>
          {branding.login_welcome_text && (
            <p className="mt-4 text-blue-200/60">{branding.login_welcome_text}</p>
          )}
        </div>
        <div className="relative text-sm text-blue-200/30">
          {!branding.hide_maintenova_branding && <span>Powered by Maintenova</span>}
        </div>
      </div>

      {/* Right panel — form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#060a1f]">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden mb-8 text-center">
            <img
              src={branding.logo_url}
              alt={branding.brand_name}
              className="h-10 mx-auto"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
